import { RootState } from "../index";

export const getSlice = (state: RootState) => state.app;
export const getIsUserChecked = (state: RootState) => getSlice(state).isUserChecked;
export const getUserProfile = (state: RootState) => getSlice(state).userProfile;
export const getIsCreateContractModalOpen = (state: RootState) => getSlice(state).isCreateContractModalOpen;
